module.exports = __webpack_public_path__ + "media/partners/norauto-4bed3022.svg";